export const SET_DASHBOARD_DETAILS = "SET_DASHBOARD_DETAILS";
export const RESET_DASHBOARD_REDUCER = "RESET_DASHBOARD_REDUCER";
export const SET_RECENT_TRANSACTIONS = "SET_RECENT_TRANSACTIONS";
export const SET_DASHBOARD_PIE_DETAILS = "SET_DASHBOARD_PIE_DETAILS";
